<template>
  <b-modal class="customer-show-ortho-elastic" id="customer-show-ortho-elastic" ref="modal" :title="dialog_title"
    hide-footer>
    <div class="form-group row">
      <div class="col-md-4">
        <select v-model="is_current" id="show_elastic_is_current" class="custom-select">
          <option :value="1">Activo</option>
          <option :value="0">Inactivo</option>
        </select>
        <label class="wabident-info" for="show_elastic_is_current">Estado</label>
      </div>

      <div class="col-md-4">
        <input type="date" id="show_elastic_date_start" class="form-control" v-model="date_start" />
        <label for="show_elastic_date_start" class="wabident-info">Fecha Inicio</label>
      </div>

      <div class="col-md-4">
        <input type="date" id="show_elastic_date_end" class="form-control" v-model="date_end" />
        <label for="show_elastic_date_end" class="wabident-info">Fecha Fin</label>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-md-3">
        <single-tooth-selector id="show_elastic_tooth_1" v-model="tooth_1"></single-tooth-selector>
        <label for="show_elastic_tooth_1" class="wabident-info">Pieza 1</label>
      </div>

      <div class="col-md-3">
        <single-tooth-selector id="show_elastic_tooth_2" v-model="tooth_2"></single-tooth-selector>
        <label for="show_elastic_tooth_2" class="wabident-info">Pieza 2</label>
      </div>

      <div class="col-md-3">
        <single-tooth-selector id="show_elastic_tooth_3" v-model="tooth_3"></single-tooth-selector>
        <label for="show_elastic_tooth_3" class="wabident-info">Pieza 3</label>
      </div>

      <div class="col-md-3">
        <single-tooth-selector id="show_elastic_tooth_4" v-model="tooth_4"></single-tooth-selector>
        <label for="show_elastic_tooth_4" class="wabident-info">Pieza 4</label>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-md-4">
        <wabident-dropdown name="show_elastic_len" v-model="length" :options="elastic_options.len"></wabident-dropdown>
        <label for="show_elastic_len" class="wabident-info">Largo</label>
      </div>

      <div class="col-md-2">
        <wabident-dropdown name="show_elastic_tension" v-model="tension"
          :options="elastic_options.tension"></wabident-dropdown>
        <label for="show_elastic_tension" class="wabident-info">Tensión</label>
      </div>

      <div class="col-md-3">
        <wabident-dropdown name="show_elastic_position" v-model="position"
          :options="elastic_options.position"></wabident-dropdown>
        <label for="show_elastic_position" class="wabident-info">Posición</label>
      </div>

      <div class="col-md-3">
        <select v-model="type" id="show_elastic_type" class="custom-select">
          <option value="elastic">Elástico</option>
          <option value="bracket">Bracket</option>
          <option value="extraction">Extracción</option>
        </select>
        <label class="wabident-info" for="show_elastic_type">Estado</label>
      </div>
    </div>

    <div class="form-group row mt-5">
      <div class="col text-center">
        <button :disabled="is_loading" type="button" @click="onSubmit" class="btn btn-primary btn-wabident">
          <span v-if="is_loading">Guardando ...</span>
          <span v-else-if="is_editing">Modificar</span>
          <span v-else>Crear</span>
          <i v-if="is_loading" class="fas fa-circle-notch float-right"></i>
        </button>
      </div>
    </div>

  </b-modal>
</template>

<script>
export default {
  props: ['customer'],
  data() {
    return {
      is_loading: false,
      elastic_id: null,
      is_current: 1,
      date_start: null,
      date_end: null,
      tooth_1: 0,
      tooth_2: 0,
      tooth_3: 0,
      tooth_4: 0,
      length: '',
      tension: '',
      type: 'elastic',
      position: '',
      elastic_options: {},
    }
  },
  computed: {
    is_editing() {
      return this.elastic_id != null;
    },
    dialog_title() {
      return this.elastic_id ? 'Editar Elástico' : 'Crear Elástico';
    },
    ...mapGetters(['clinic', 'msgwindow'])
  },
  methods: {
    loadElasticOptions() {
      axios.get(`/clinic/${this.clinic.id}/elastic_options`).then((response) => {
        this.elastic_options = response.data;
      }).catch((err) => {
        this.msgwindow.error('Error cargando opciones de Elásticos. Contacta con el Administrador');
      });
    },
    onSubmit() {
      if (this.is_loading) {
        return true;
      }

      this.is_loading = true;

      let params = {
        is_current: this.is_current,
        date_start: this.date_start,
        date_end: this.date_end,
        tooth_1: this.tooth_1,
        tooth_2: this.tooth_2,
        tooth_3: this.tooth_3,
        tooth_4: this.tooth_4,
        length: this.length,
        tension: this.tension,
        position: this.position,
        type: this.type,
      }

      let uri = `/customer/${this.customer.id}/elastics`;
      if (this.is_editing) {
        uri = `/customer/${this.customer.id}/elastics/${this.elastic_id}`;
        params['_method'] = 'patch';
      }

      axios.post(uri, params)
        .then((response) => {
          this.msgwindow.success('Elástico guardado');
          this.$refs.modal.hide();
          this.$emit('submit');
        }).catch((error) => {
          this.msgwindow.error('Error guarando elástico. Contacta con el Administrador')
        }).then(() => {
          this.is_loading = false;
        });
    },
    showNew(selected_tooth = []) {
      this.is_loading = false;
      this.elastic_id = null;
      this.is_current = 1;
      this.date_start = new Date().toISODate();
      this.date_end = null;
      this.tooth_1 = selected_tooth[0] || 0;
      this.tooth_2 = selected_tooth[1] || 0;
      this.tooth_3 = selected_tooth[2] || 0;
      this.tooth_4 = selected_tooth[3] || 0;
      this.length = '';
      this.tension = '';
      this.position = '';
      this.type = 'elastic';

      this.$refs.modal.show();
    },
    showEdit(elastic) {
      this.is_loading = false;
      this.elastic_id = elastic.id;
      this.is_current = elastic.is_current;
      this.date_start = elastic.date_start;
      this.date_end = elastic.date_end;
      this.tooth_1 = elastic.tooth_1;
      this.tooth_2 = elastic.tooth_2;
      this.tooth_3 = elastic.tooth_3;
      this.tooth_4 = elastic.tooth_4;
      this.length = elastic.length;
      this.tension = elastic.tension;
      this.position = elastic.position;
      this.type = elastic.type;

      this.$refs.modal.show();
    }
  },
  mounted() {
    this.loadElasticOptions();
  }
}
</script>

<style lang="scss">
#customer-show-ortho-elastic {
  .modal-dialog {
    max-width: 40%;
  }
}
</style>
